import { createSelector } from 'reselect'

import { NetworkContentRootState } from '../networkContentRoot.reducer'

export const getFacebookFeeds = createSelector(
  (state: NetworkContentRootState) => {
    return state.facebookStore.facebookFeeds
  },
  (state) => state,
)
